import { BaseFieldView } from '../BaseField/views';

export const StopwatchFieldView = BaseFieldView.extend({
    template: '#tpl_stopwatch_field',
    model: null, // MobileStopwatchField
    className: 'form-field stopwatch_field',
    interval_id: null, // id for the current running timer
    timer_value: 0, // Keeps track of running timer

    events: {
        'click .stopwatch_start_button': 'click_start_stopwatch',
        'click .stopwatch_stop_button': 'save_field_value',
        'click .stopwatch_reset_button': 'reset_stopwatch'
    },

    initialize: function () {
        var this_ = this;

        this.listenTo(this.model, 'stopwatch_changed', this.render);
        this.listenTo($f.application.vent, 'mobile:blur', function () {
            this_.clear_interval();
        });
        this.listenTo($f.application.vent, 'mobile:focus', function () {
            if (!this_.model.start_date) {
                return;
            }
            this_.render();
        });

        StopwatchFieldView.__super__.initialize.apply(this, arguments);
    },

    templateHelpers: function () {
        return $.extend(
            {
                formatted_time: this.model.get('value')
                    ? $f.utils.get_string_from_milliseconds(this.model.get('value'), 'centiseconds')
                    : '00:00:00.00',
                allow_stopwatch: this.model.get('metadata') && !!this.model.get('metadata').allow_stopwatch,
                is_running: !!this.model.start_date,
                pass_fail_class_name: this._get_acceptance_criteria_class()
            },
            StopwatchFieldView.__super__.templateHelpers.apply(this, arguments)
        );
    },

    onRender: function () {
        var this_ = this;

        this.clear_interval();

        this.timer_value = 0;
        if (this.model.start_date) {
            this.start_stopwatch(true);
        }

        this.$el
            .find('.show_timespan_picker')
            .mobiscroll()
            .timespan({
                theme: 'mobiscroll',
                display: 'bottom',
                defaultValue: this.model.get('value') || undefined,
                wheelOrder: 'hhiiss',
                max: 86399000, // Maximum selectable time in ms: 23 hours 59 minutes 59 seconds
                onSet: function (event, inst) {
                    this_.save_value(inst.getVal());
                }
            });
    },

    clear_interval: function () {
        clearInterval(this.interval_id);
        this.interval_id = null;
    },

    click_start_stopwatch: function (event) {
        this.start_stopwatch(false);
        return false;
    },

    start_stopwatch: function (skip_render) {
        var this_ = this;

        this.timer_value = this.model.start_date ? moment().valueOf() - this.model.start_date : 0;
        this.clear_interval();
        this.interval_id = setInterval(function () {
            this_._update_display();
        }, 50);

        this.model.start_stopwatch(this.interval_id);

        if (!skip_render) {
            this.render(false); // clear_interval = false so we don't infinite loop
        }
    },

    // Handles case where we want to save the stopwatch value while the stopwatch is minimized
    save_field_value: function () {
        this.save_value(moment().valueOf() - this.model.start_date);
        return false;
    },

    _update_display: function () {
        this.timer_value = moment().valueOf() - this.model.start_date;

        this.$el
            .find('.stopwatch_field_timer')
            .text($f.utils.get_string_from_milliseconds(this.timer_value, 'centiseconds'));
    },

    // Allows for timespan mobiscroll to pass in an epoch value instead of stop_date - start_date
    save_value: function (value) {
        this.$el.removeClass('invalid'); // innocent until proven guilty
        this.model.stop_stopwatch(value);
        this.model.trigger('change', this.model);
        // dependent fields are displayed by a listener which is set to capture `change:value` events.
        this.model.trigger('change:value', this.model);
    },

    reset_stopwatch: function (event) {
        this.timer_value = 0;
        this.model.reset_stopwatch();
        this.render();

        return false;
    },

    onClose: function () {
        this.clear_interval();
    }
});
